<template>
    <span v-if="item" >
        <strong>HD Sync:</strong>&nbsp;
        <a href="javascript:void(0);" title="Sync Docs URL" class="text-warning" @click="copySyncDocsUrl(item)"><i class="fa fa-link"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD Sync URL" class="text-info" @click="copyHDSyncURL(item)"><i class="fa fa-sync"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD Sync JSON" class="text-info" @click="copyHDSyncJSON(item)"><i class="fa fa-file"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD Article Link" class="text-info" @click="copyHDArticleLink(item)"><i class="fa fa-info"></i></a>&nbsp;
        <a href="javascript:void(0);" title="DevOps to HD Create URL" class="text-primary" @click="copyDevOpsCreateHDURL(item)"><i class="fa fa-plus"></i></a>&nbsp;<br/><br/>
        
        <strong>ADO Sync:</strong>&nbsp;
        <a href="javascript:void(0);" title="DevOps Sync Comment" class="text-primary" @click="copyDevOpsCommentURL(item)"><i class="fa fa-comment-alt"></i></a>&nbsp;
        <a href="javascript:void(0);" title="DevOps Sync URL" class="text-primary" @click="copyDevOpsStatusURL(item)"><i class="fa fa-sync"></i></a>&nbsp;
        <a href="javascript:void(0);" title="DevOps Aritcle Link" class="text-primary" @click="copyDevOpsArticleLink(item)"><i class="fa fa-info"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD to ADO Create URL" class="text-danger" @click="copyHDAutoCreateURL(item)"><i class="fa fa-plus"></i></a>&nbsp;
        <a href="javascript:void(0);" title="HD to ADO Create JSON" class="text-danger" @click="copyHDAutoCreateJSON(item)"><i class="fa fa-file"></i></a>&nbsp;<br/>
    </span>
</template>
<style scoped>
    .fa{
        font-size: 1.5rem;
    }
</style>
<script>
import Vue from "vue";
import CommonFactory from '@/mixins/common.factory';
export default Vue.extend({
    mixins:[CommonFactory],
    data() {
        return {
            type:'',
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        onCopy(e){
            this.userMsg={show:true,type:'primary',list:['You just copied: ' + e.text]};
        },
        async doCopyVal(message,successMsg){
            const _self=this;
            let isCopied=await _self.$copyText(message)
            if(isCopied){
                _self.userMsg={show:true,type:'primary',list:['You just copied: ' + successMsg?successMsg:message]};
            }
        },
        copyHDAutoCreateJSON(item){
            const _self=this;
            let hdJSONString;
            switch(item.requestType){
                case 'zendesk-devops':
                    hdJSONString={
                        "zendesk_webhook":{
                            "ticket_id":"{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "brandname":"{{ticket.brand.name}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}",
                            "attachments1":"{{ticket.latest_comment.attachments}}",
                            "fields": {
                                "System.TeamProject": "First Project",
                                "System.Title": "{{ticket.title}}",
                                "Microsoft.VSTS.Common.Priority": "{{ticket.priority}}",
                                "System.WorkItemType": "Issue",
                                "Microsoft.VSTS.Common.Severity": "",
                                "System.Tags": "test",
                                "System.AreaPath": "First Project\\Child2",
                                "System.IterationPath": "First Project\\Iteration2",
                                "Custom.Development": "dev",
                                "Microsoft.VSTS.TCM.ReproSteps": ""
                            },
                            "project": {
                                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                                "name": "First Project"
                            },
                            "hdTicketId": 45,
                            "auth": {
                                "requestType": "{{requestType}}",
                                "hdLoginUrl":"{{hdLoginUrl}}",
                                "devOpsUrl": "{{devOpsUrl}}",
                                "hdBrandLoginUrl": "{{hdLoginUrl}}",
                                "appId": "{{appId}}",
                                "installationId": "{{installationId}}"
                            },
                            "user": {
                                "id": "{{current_user.id}}",
                                "email": "{{current_user.email}}",
                                "name": "{{current_user.name}}"
                            }
                        }
                    }
                    break;
                    case 'freshdesk-devops':
                    hdJSONString={
                        "freshdesk_webhook": {
                            "ticket_id": "{{ticket.id}}",
                            "ticket_url": "{{hdLoginUrl}}/a/tickets/{{ticket.id}}",
                            "brandname": "{{helpdesk_name}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}",
                            "attachments": "",
                            "fields": {
                                "System.TeamProject": "First Project",
                                "System.Title": "{{ticket.subject}}",
                                "Microsoft.VSTS.Common.Priority": "{{ticket.priority}}",
                                "System.WorkItemType": "Issue",
                                "Microsoft.VSTS.Common.Severity": "",
                                "System.Tags": "test",
                                "System.AreaPath": "First Project\\Child2",
                                "System.IterationPath": "First Project\\Iteration2",
                                "Custom.Development": "dev",
                                "Microsoft.VSTS.TCM.ReproSteps": ""
                            },
                            "project": {
                                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                                "name": "First Project"
                            },
                            "hdTicketId": "{{ticket.id}}",
                            "auth": {
                                "requestType": "{{requestType}}",
                                "hdLoginUrl":"{{hdLoginUrl}}",
                                "devOpsUrl": "{{devOpsUrl}}",
                                "hdBrandLoginUrl": "{{hdLoginUrl}}",
                                "appId": "{{appId}}",
                                "installationId": "{{installationId}}"
                            },
                            "user": {
                                "id": "{{ticket.agent.id}}",
                                "email": "{{ticket.agent.email}}",
                                "name": "{{ticket.agent.name}}"
                            }
                        }
                    }
                    break;
                    case 'freshservice-devops':
                    hdJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url": "{{hdLoginUrl}}/helpdesk/tickets/{{ticket.id}}",
                            "brandname": "{{helpdesk_name}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}",
                            "attachments": "",
                            "fields": {
                                "System.TeamProject": "First Project",
                                "System.Title": "{{ticket.subject}}",
                                "Microsoft.VSTS.Common.Priority": "{{ticket.priority}}",
                                "System.WorkItemType": "Issue",
                                "Microsoft.VSTS.Common.Severity": "",
                                "System.Tags": "test",
                                "System.AreaPath": "First Project\\Child2",
                                "System.IterationPath": "First Project\\Iteration2",
                                "Custom.Development": "dev",
                                "Microsoft.VSTS.TCM.ReproSteps": ""
                            },
                            "project": {
                                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                                "name": "First Project"
                            },
                            "hdTicketId": "{{ticket.id}}",
                            "auth": {
                                "requestType": "{{requestType}}",
                                "hdLoginUrl":"{{hdLoginUrl}}",
                                "devOpsUrl": "{{devOpsUrl}}",
                                "hdBrandLoginUrl": "{{hdLoginUrl}}",
                                "appId": "{{appId}}",
                                "installationId": "{{installationId}}"
                            },
                            "user": {
                                "id": "{{ticket.agent.id}}",
                                "email": "{{ticket.agent.email}}",
                                "name": "{{ticket.agent.name}}"
                            }
                        }
                    }
                    break;
            }

            hdJSONString=JSON.stringify(hdJSONString);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{hdLoginUrl}}",item.hdLoginUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{devOpsUrl}}",item.devOpsUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{appId}}",item.appId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{installationId}}",item.installationId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{requestType}}",item.requestType);
            console.log(JSON.parse(hdJSONString));
            _self.doCopyVal(JSON.stringify(hdJSONString),'HD JSON copied');
        },
        copySyncDocsUrl(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url=`https://devopsintegration.io/el/sync-setup/devops/${item.requestType}/${item.userId}/${item.appId}/${item.installationId}/${item.userEmail}/${account}?appId=${item.appId}&installationId=${item.installationId}&account=${account}`;
            _self.doCopyVal(url,'Sync Docs URL copied');
            setTimeout(function(){
                window.open(url,'_blank');
            },2500);
        },
        copyHDAutoCreateURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url=`https://devopsintegration.io/api/${item.requestType}/${type}/create?appId=${item.appId}&installationId=${item.installationId}&account=${account}`;
            
            _self.doCopyVal(url,'HD Auto Create URL copied');
        },
        //ado to hd ticket create
        copyDevOpsCreateHDURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let url=`https://devopsintegration.io/api/${item.requestType}/devops/create?appId=${item.appId}&installationId=${item.installationId}`;
            
            _self.doCopyVal(url,'DevOps Create HD URL copied');
        },
        //hd
        copyHDArticleLink(item){
            const _self=this;
            let hdArticleLink='';
            switch(item.requestType){
                case 'zendesk-devops':
                    hdArticleLink='https://docs.google.com/document/d/1gDjTRGRNPlni3pJiRFkdXOCEErwQo1alkBZ-JbNuiBA/edit?usp=sharing';
                    break;
                    case 'freshdesk-devops':
                    hdArticleLink='https://docs.google.com/document/d/1uTaFI8B89yjVuoK--0Lg8sHUTHhMAZ7lcCI9Lk_ZwQg/edit?usp=sharing';
                    break;
                    case 'freshservice-devops':
                    hdArticleLink='https://docs.google.com/document/d/1WyWx7Tj3ISK6YdXPzNm3k7x4y7SyejynE_eV2DPUfk8/edit?usp=sharing';
                    break;
            }

            _self.doCopyVal(hdArticleLink,'HD Article Link copied');
        },
        copyHDSyncJSON(item){
            const _self=this;
            let hdJSONString;
            switch(item.requestType){
                case 'zendesk-devops':
                    hdJSONString={
                        "zendesk_webhook":{
                            "ticket_id":"{{ticket.id}}",
                            "comment_id":"{{ticket.latest_comment.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "account":"{{ticket.account}}",
                            "ticket_status":"{{ticket.status}}",
                            "brandname":"{{ticket.brand.name}}",
                            "current_username":"{{current_user.name}}",
                            "current_useremail":"{{current_user.email}}",
                            "current_user_first_name":"{{current_user.first_name}}",
                            "ticket_latest_comment_formatted":"{{ticket.latest_comment_formatted}}",
                            "ticket_latest_comment":"{{ticket.latest_comment}}",
                            "is_public":"{{ticket.latest_comment.is_public}}",
                            "attachments":"{{ticket.latest_comment.attachments}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl":"{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'freshdesk-devops':
                    hdJSONString={
                        "freshdesk_webhook": {
                            "ticket_id": "{{ticket.id}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url": "{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment": "{{ticket.latest_private_comment}}",
                            "ticket_latest_private_comment_text1": "{{ticket.latest_private_comment_text1}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "ticket_agent_name": "{{ticket.agent.name}}",
                            "ticket_agent_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
                    case 'freshservice-devops':
                    hdJSONString={
                        "freshservice_webhook": {
                            "ticket_id": "{{ticket.id_numeric}}",
                            "ticket_id_str": "{{ticket.id}}",
                            "ticket_url":"{{ticket.url}}",
                            "ticket_status": "{{ticket.status}}",
                            "latest_comment":"{{ticket.latest_private_comment}}",
                            "ticket_latest_private_comment1":"{{ticket.latest_private_comment}}",
                            "helpdesk_name": "{{ticket.portal_url}}",
                            "LastComment_Name": "{{comment.commenter.name}}",
                            "LastComment1": "{{comment.body}}",
                            "current_user_name": "{{ticket.agent.name}}",
                            "current_user_email": "{{ticket.agent.email}}",
                            "hdLoginUrl":"{{hdLoginUrl}}",
                            "devOpsUrl": "{{devOpsUrl}}"
                        }
                    }
                    break;
            }

            hdJSONString=JSON.stringify(hdJSONString);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{hdLoginUrl}}",item.hdLoginUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{devOpsUrl}}",item.devOpsUrl);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{appId}}",item.appId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{installationId}}",item.installationId);
            hdJSONString=_self.fn().replaceAll(hdJSONString,"{{requestType}}",item.requestType);
            console.log(JSON.parse(hdJSONString));
            _self.doCopyVal(JSON.stringify(hdJSONString),'HD JSON copied');
        },
        copyHDSyncURL(item){
            const _self=this;
            let type=item.requestType.split('-')[0];
            let account=item.hdLoginUrl;
            account=account.replace('https://','');
            account=account.split('.')[0];
            let url=`https://devopsintegration.io/api/${item.requestType}/${type}/syncing?appId=${item.appId}&installationId=${item.installationId}&account=${account}`
            _self.doCopyVal(url,'HD Syncing URL copied');
        },
        //devops
        copyDevOpsArticleLink(item){
            const _self=this;
            let devopsArticleLink='';
            switch(item.requestType){
                case 'zendesk-devops':
                    devopsArticleLink='https://docs.google.com/document/d/169BfKDscRBfpRyMgEZXpS0inLToPCAbarwyZgCeQ57s/edit?usp=sharing';
                break;
                case 'freshdesk-devops':
                    devopsArticleLink='https://docs.google.com/document/d/1mC84XrdUwOiR5izSAf7Gn3l6tbqsH6i4I-HrXB9eBs0/edit?usp=sharing';
                break;
                case 'freshservice-devops':
                    devopsArticleLink='https://docs.google.com/document/d/1HQAyKoIfX45kiL5a-iIYPUHe8mosJaadfrG26kTtsag/edit?usp=sharing';
                break;
            }
            _self.doCopyVal(devopsArticleLink,'DevOps Article Link copied');
        },
        copyDevOpsCommentURL(item){
            const _self=this;
            let url=`https://devopsintegration.io/api/${item.requestType}/devops/syncing/comment?appId=${item.appId}&installationId=${item.installationId}`
            _self.doCopyVal(url,'DevOps Comment URL copied');
        },
        copyDevOpsStatusURL(item){
            const _self=this;
            //let url=`https://devopsintegration.io/api/freshdesk-devops/devops/syncing?appId=fd_118&installationId=fd_118`
            let url=`https://devopsintegration.io/api/${item.requestType}/devops/syncing?appId=${item.appId}&installationId=${item.installationId}&comment=0`
            _self.doCopyVal(url,'DevOps Status URL copied')
        }
    }
});
</script>
